let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("73tGl"), load("dWaws"), load("rYNvl")]).then(() => parcelRequire('duLvl'));